export default __webpack_public_path__ + "static/media/stripe_customer_portal.887671b8.png";